import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconBase } from './iconBase';
export const Close = ({ type, ...rest })=>/*#__PURE__*/ _jsx(IconBase, {
        viewBox: "0 0 24 24",
        ...rest,
        children: type === 'stroke' ? /*#__PURE__*/ _jsx("path", {
            d: "M5 5L19 19M19 5L5 19",
            stroke: "currentColor",
            strokeWidth: "1.75",
            strokeLinecap: "round"
        }) : /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L12 10.5858L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L13.4142 12L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L12 13.4142L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L10.5858 12L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
            fill: "currentColor"
        })
    });

//# sourceMappingURL=close.js.map